import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const EventCard = ({ event }) => {
  const navigate = useNavigate();

  const handleEventClick = () => {
    navigate('/event-detail', { state: { eventId: event?.id } });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return {
      month: date?.toLocaleDateString('en-US', { month: 'short' }),
      day: date?.getDate(),
      weekday: date?.toLocaleDateString('en-US', { weekday: 'short' })
    };
  };

  const dateInfo = formatDate(event?.date);

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 overflow-hidden hover:shadow-elevation-3 transition-shadow duration-200">
      {/* Event Image */}
      <div className="relative h-48 overflow-hidden">
        <Image
          src={event?.image}
          alt={event?.title}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
        />
        
        {/* Date Badge */}
        <div className="absolute top-3 left-3 bg-white rounded-lg p-2 text-center shadow-elevation-2">
          <div className="text-xs font-medium text-muted-foreground uppercase">
            {dateInfo?.month}
          </div>
          <div className="text-lg font-bold text-foreground leading-none">
            {dateInfo?.day}
          </div>
          <div className="text-xs text-muted-foreground">
            {dateInfo?.weekday}
          </div>
        </div>

        {/* Category Badge */}
        {event?.category && (
          <div className="absolute top-3 right-3 bg-primary text-primary-foreground px-2 py-1 rounded-md text-xs font-medium">
            {event?.category}
          </div>
        )}
      </div>
      {/* Event Details */}
      <div className="p-4">
        <h3 className="text-lg font-semibold text-foreground mb-2 line-clamp-2">
          {event?.title}
        </h3>
        
        <div className="space-y-2 mb-4">
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="MapPin" size={14} />
            <span className="truncate">{event?.venue}</span>
          </div>
          
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Clock" size={14} />
            <span>{event?.time}</span>
          </div>
          
          {event?.distance && (
            <div className="flex items-center space-x-2 text-sm text-muted-foreground">
              <Icon name="Navigation" size={14} />
              <span>{event?.distance} away</span>
            </div>
          )}
        </div>

        {/* Price and Action */}
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            <span className="text-xs text-muted-foreground">Starting at</span>
            <span className="text-lg font-bold text-foreground">
              {event?.startingPrice === 0 ? 'Free' : `$${event?.startingPrice}`}
            </span>
          </div>
          
          <Button
            variant="default"
            size="sm"
            onClick={handleEventClick}
            iconName="ArrowRight"
            iconPosition="right"
          >
            View Event
          </Button>
        </div>

        {/* Additional Info */}
        {event?.ticketsLeft && event?.ticketsLeft < 50 && (
          <div className="mt-3 flex items-center space-x-1 text-xs text-warning">
            <Icon name="AlertTriangle" size={12} />
            <span>Only {event?.ticketsLeft} tickets left!</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventCard;